exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Colors */\n/* Borders */\n/* Media */\n/* \n    420px because it will not allow 3 buttons\n    at 30% with 10px margins to be displayed \n    on a single line.\n*/\n/* Common sizes */\n/* z indices */\n.cs-QuestionUpdateError {\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  line-height: 1.8em;\n  letter-spacing: .1em;\n  text-align: left;\n  border: 1px dashed #ccc;\n  background-color: #ffe;\n  color: #b00;\n}\n.cs-QuestionUpdateError__left-box {\n  display: none;\n  font-size: 28px;\n  padding: 7px;\n}\n@media screen and (min-width: 420px) {\n  .cs-QuestionUpdateError__left-box {\n    display: block;\n  }\n}\n.cs-QuestionUpdateError__right-box {\n  flex: 1;\n  text-align: right;\n}\n.cs-QuestionUpdateError__response {\n  text-transform: uppercase;\n  font-size: 12px;\n  color: #a66;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/QuestionUpdateError/QuestionUpdateError.less
// module id = 904
// module chunks = 0